import React from 'react';

const ClientHubPayment = (props: {
  isMobile: boolean;
  activeSection: string;
  track: Function;
  sitelinkId: string;
  storePhone: string;
  local: 'en' | 'fr';
}) => {
  const { isMobile, activeSection, track, sitelinkId, storePhone, local } =
    props;
  const id = 'payment';

  const showSection = () => {
    if (isMobile) return activeSection === id;
    return true;
  };

  const t = {
    title: local === 'fr' ? 'Paiements' : 'Payments',
    billingInfo:
      local === 'fr'
        ? 'La facturation se fait sur un cycle de quatre (4) semaines, à partir de votre date d’emménagement. Vous ne devez régler que le cycle de facturation en cours. Pour de plus amples renseignements, consultez la section FAQ.'
        : 'Accounts are billed on a 4-week cycle from your move-in date. You only need to pay the current cycle. For more information, please see the FAQs section.',

    payOnline: local === 'fr' ? 'Paiements en ligne' : 'Pay online',
    visitPortal:
      local === 'fr'
        ? 'Consultez notre portail client sécurisé :'
        : 'Visit our secure client portal:',

    myAccount: local === 'fr' ? 'Mon compte' : 'My Account',
    loginSteps:
      local === 'fr'
        ? [
            '1. Sélectionnez votre unité.',
            '2. Cliquez sur « Effectuer un paiement » pour payer par carte de crédit ou prélèvement automatique.',
          ]
        : [
            '1. Select your unit',
            '2. Go to "Make a Payment" to pay by credit card or direct debit',
          ],

    payByPhone: local === 'fr' ? 'Paiements par téléphone' : 'Pay by phone',
    callUs: local === 'fr' ? 'Appelez-nous au' : 'Call us at',
    phoneHelp:
      local === 'fr'
        ? 'et nous vous aiderons à effectuer votre paiement.'
        : 'and we’ll help process your payment.',
  };

  return (
    <div style={{ display: showSection() ? 'block' : 'none' }}>
      <h3
        id="payment"
        style={{ textTransform: 'none', backgroundColor: 'aliceblue' }}
      >
        {t.title}
      </h3>
      <div>
        {t.billingInfo}
        <br />
        <br />
        <div>
          <b>{t.payOnline}</b>
          <br />
          {t.visitPortal}{' '}
          <a
            style={{ textDecoration: 'none' }}
            target="_blank"
            rel="noreferrer"
            onClick={() => track('Open MyAccount')}
            href={`https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=${sitelinkId}==&1=1`}
          >
            {t.myAccount}
          </a>
          <br />
          {local === 'fr' ? 'Une fois connecté(e) :' : 'Once logged in:'}
          <br />
          {t.loginSteps.map((step, index) => (
            <span key={index} style={{ paddingLeft: '10px', display: 'block' }}>
              {step}
            </span>
          ))}
        </div>

        <hr />

        <div>
          <b>{t.payByPhone}</b>
          <br />
          {t.callUs}{' '}
          <a
            style={{ textDecoration: 'none' }}
            onClick={() => track('Call store')}
            href={`tel:${storePhone}`}
          >
            {storePhone}
          </a>{' '}
          {t.phoneHelp}
          <br />
        </div>
      </div>

      <hr />
      <br />
    </div>
  );
};

export default ClientHubPayment;
